// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var markdownBody = "Markdown-module--markdown-body--2WmpD";
export var anchorGradient = "Markdown-module--anchor-gradient--1-3Uk";